import React from "react";
import { Link } from 'react-router-dom';
import backBtn from '../../../assets/images/arrow-left_1.svg';
import { EnquiriesHead } from '../../../components';
import endSuction from '../../../assets/images/endSuctionSelected.jpg';
import horizontalPump from '../../../assets/images/horizontal-pump.png';
import verticalPump from '../../../assets/images/vertical-pump.png';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useState, useRef,useEffect } from "react";
import AES from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";
import { useNavigate, useLocation } from "react-router-dom";
import customFetch  from "../../../utils/axios";
import { Paginator } from 'primereact/paginator';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { clearValues } from '../../../features/cart/cartSlice';
import ToastMessage from '../../../components/ToastMessage';

const FirePumpStockBookingMobile = () => {
        
        /**hooks */
        const dt = useRef(null);
      
        const dispatch = useDispatch();
        const { status_api, message_api,isReload } = useSelector((store) => store.cartBooking);
        /**states */
        const [selectedProducts, setSelectedProducts] = useState(null);
        const [pagelimit, setPageLimit] = useState(10); 
        const [stocklist, setStockList] = useState([]);
        const [apiSuccessMessage, setApiSuccessMessage] = useState('');
        const [pageNo, setpageNo] = useState(0);
        const [checkedItems, setCheckedItems] = useState([]);
        const [checkeddata, setCheckedData] = useState([]);
        const [checkedcode, setCheckedCode] = useState([]);
        const [effectRan, setEffectRan] = useState(true);

        const [filter_values, setFilterValue] = useState({});
        const [first, setFirst] = useState(0);
        const [show_warning, setShowWarning] = useState(false);
        const [selected_pump, setSelectedPump] = useState(null);
        const [showtable, setShowTable] = useState(false);

        const [cart_qty, setCartQty] = useState(0);
        const secretKey = 'NAFFCO2023@GALAXY';
        const search = useLocation().search;
        const stockdata = new URLSearchParams(search).get('r');
        const navigation_data = new URLSearchParams(search).get('n');
        const navigate = useNavigate();

       useEffect(() => {
        if (effectRan === true) {
        if(navigation_data !== 'from_compare'){
            if (stockdata === null) {
                navigate('/stock-availability');
              } else {
                  let stockdataDecrypt = AES.decrypt(stockdata, secretKey);
    
                  if (stockdataDecrypt === "") {

                      navigate('/stock-availability');
                  }
                  else {
                      const requestRow = JSON.parse(stockdataDecrypt.toString(Utf8));
                      setFilterValue(requestRow);
                      setTimeout(() => {
                        const syntheticEvent = { preventDefault: () => {} };
                        fetchStock(syntheticEvent,requestRow);
                      }, 500);
                      
                  }
                }
            }else{
                var filtervalues = JSON.parse(sessionStorage.getItem('filter_values'));
                setFilterValue(filtervalues);
                setCheckedCode(JSON.parse(sessionStorage.getItem('checkedcode')));
                setCheckedItems(JSON.parse(sessionStorage.getItem('checkeditems')));
                setCheckedData(JSON.parse(sessionStorage.getItem('checkeddata')));                
                setTimeout(() => {
                    const syntheticEvent = { preventDefault: () => {} };
                    fetchStock(syntheticEvent,filtervalues);
                  }, 500);
            }
            setEffectRan(false)
        }

    }, [stockdata]);

    useEffect(() => {
        if(Object.keys(filter_values).length>0 ){
            setTimeout(() => {
                const syntheticEvent = { preventDefault: () => {} };
                fetchStock(syntheticEvent,filter_values);
            }, 500);  
        }
        }, [pageNo]);

        useEffect(() => {
            setApiSuccessMessage('');

            if(status_api===true) {
                if(Object.keys(filter_values).length>0 ){
                    setApiSuccessMessage(message_api);
                    setTimeout(() => {
                        const syntheticEvent = { preventDefault: () => {} };
                        fetchStock(syntheticEvent,filter_values);
                    }, 500); 
                    window.scrollTo(0, 0); 
                }
            }
            if(isReload === true){
                if(Object.keys(filter_values).length>0 ){
                setTimeout(() => {
                    const syntheticEvent = { preventDefault: () => {} };
                    fetchStock(syntheticEvent,filter_values);
                }, 500); 
                dispatch(clearValues());
            }
            }
          }, [status_api,isReload,message_api]);

        const fetchStock = async (event,requestRow) => {
            event.preventDefault();
            requestRow['session_id'] = localStorage.getItem('sessionId');
            setStockList([])
            try {
                const response = await customFetch.get(`/stock_available/`+pagelimit+`?page=`+pageNo,{
                    params: {filter_data: requestRow}
                    });
                const stocklist = response.data.stocklist;
                setShowTable(true);
                setStockList(stocklist);

            } catch (err) {

                window.scrollTo(0,0);
            }
        };
        const flowName = (flowName) =>{
            return (
              <div  style={{ textTransform: 'capitalize'}}>{flowName.flow} {flowName.flow_uom}</div>
            );
        } 
        const modelName = (data) =>{
            let urldata = {id:data.id, 'frompage':'stockpump','showsubmital':0,'location':data.location}
            let filterData = AES.encrypt(JSON.stringify(urldata), secretKey).toString();
            let finalid = 'r=' + encodeURIComponent(filterData);
            let viewdata = "/view-pump-data?"+finalid ;
            sessionStorage.setItem('checkedcode', JSON.stringify(checkedcode));
            // sessionStorage.setItem('filter_values', JSON.stringify(filter_values));
            sessionStorage.setItem('checkeditems', JSON.stringify(checkedItems));
            sessionStorage.setItem('checkeddata', JSON.stringify(checkeddata));
            return ( 
                <Link to={viewdata}> 
                <div className="newUser" style={{ textTransform: 'capitalize'}}>{data.model}</div>
                 </Link>
            );
        } 
        const pressureName = (pressureName) =>{
            return (
              <div className="newUser" style={{ textTransform: 'capitalize'}}>{pressureName.pressure} {pressureName.pressure_uom}</div>
            );
        }
        const location = (data) =>{
            return (
              <div className="newUser" style={{ textTransform: 'capitalize'}}>{data.location}</div>
            );
        }
        const qtyavail = (data) =>{
            return (
              <div className="newUser" style={{ textTransform: 'capitalize',alignItems:'center',display: 'flex'}}>{data.qty_avl}</div>
            );
        } 
        const handleClose = () => {
            setShowWarning(false);
        }
        const handleCheckBoxChange = (event, data) => {
            setSelectedPump(null);
            const isChecked = event.target.checked;
            if (isChecked) {
                if(checkedItems.includes(data.loc_id) === false){
                    if (checkedItems && checkedItems.length < 3) {
                        if(checkedcode.includes(data.code) !== false){
                            setSelectedPump(data.code);
                            setShowWarning(true);
                            return false;
                        }   
                        setCheckedItems([...checkedItems, data.loc_id]); // Add the checkbox ID to the array
                        setCheckedData([...checkeddata,{'id':data.loc_id, 'code':data.code,'pump_type':data.pump_type,'model':data.model}])
                        setCheckedCode([...checkedcode, data.code]); // Add the checkbox ID to the array
                    }
                }
            } else {
                setCheckedItems(checkedItems.filter((item) => item !== data.loc_id)); // Remove the checkbox ID from the array
                setCheckedData(checkeddata.filter((item) => item.id !== data.loc_id));
                setCheckedCode(checkedcode.filter((item) => item !== data.code)); // Remove the checkbox ID from the array

            }
            
        };
          const compareShow = (data) => {
            return (
                <div className="checkbox_main">
                    <div className="checkbox_container">
                    {
                     (apiSuccessMessage) && (<ToastMessage showHidePanel={true} isError={0} message={apiSuccessMessage} />)
                    }
                        <div className="checkbox_block">
                        <input type="checkbox" name="electric" id={data.loc_id}  
                        checked={checkedItems.includes(data.loc_id)}
                        onChange={(event) => handleCheckBoxChange(event, data)}/>
                        <label></label>
                        <span for="electric"></span>
                        </div>
                    </div>
            </div>
            );
          };
          const redirectToDetail = (data) => {
            if(navigation_data == 'from_compare'){
                navigate("/stock-availability");
            }
            sessionStorage.setItem('checkedcode', JSON.stringify(checkedcode));
            sessionStorage.setItem('checkeditems', JSON.stringify(checkedItems));
            sessionStorage.setItem('checkeddata', JSON.stringify(checkeddata));
    
            const rowIdEncryptedString = AES.encrypt(JSON.stringify(checkedItems), secretKey).toString();
            let finalUrl = 'r=' + encodeURIComponent(rowIdEncryptedString);
            navigate('/fire-pump-compare?' + finalUrl);
        }
        
        
        const removeSelected =(data)=>{
            setCheckedItems(checkedItems.filter((item) => item !== data.id)); // Remove the checkbox ID from the array
            setCheckedData(checkeddata.filter((item) => item.id !== data.id));
            setCheckedCode(checkedcode.filter((item) => item !== data.code)); // Remove the checkbox ID from the array
    
        }
        const onPageChange = (event) => {
            setFirst(event.first);
            let page = event.page + 1;
            // changePage(page);
            setpageNo(page);

        };
       
        const handleQuantityChange = (value,item,rowindex) => {
            // const { value } = event.target;

            if (!isNaN(value)) {
                if(value > 0){
                    insertToCart(item,value);
                    stocklist.data[rowindex].cart_qty = value;
                }
            }
            setCartQty(values => {
                return {...values, value};
            });
          };
          const setCartData =(e,loc_id,index,maxval) =>{
            const inputValue = e.target.value;
            if(parseInt(inputValue) > maxval){
                return false;
            }
            const cart_value = inputValue.replace(/\D/g, '');
            setCartQty(values => {
                return {...values, cart_value};
            });
            document.getElementsByClassName('cart_code_'+loc_id)[0].value = cart_value;
            stocklist.data[index].cart_qty = cart_value;

        }
        const addToCart = (item,index) => {
            return(
                <div className="available_carts">
                    <input type="number" 
                    value={item.cart_qty}
                    onChange={(e)=>{ setCartData(e,item.loc_id,index.rowIndex,item.qty_avl)}}
                    pattern="\d*"
                    name="cart_qty" min="0" max={item.qty_avl} className={`cart_code_${item.loc_id}`} />
                    <Link onClick={(e)=>{handleQuantityChange(item.cart_qty,item,index.rowIndex)}} >
                    <div className='cart_icon'>                          
                            <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="28" height="28" transform="translate(0.5)" fill="#ED1D24"/>
                            <g clipPath="url(#clip0_152_13176)">
                            <path d="M21.4192 9.92517C21.3797 9.86848 21.3276 9.82168 21.2671 9.7884C21.2065 9.75513 21.1391 9.73628 21.07 9.73333L12.3857 9.359C12.1365 9.34809 11.9283 9.54046 11.9177 9.78847C11.9071 10.0364 12.0991 10.2459 12.3471 10.2565L20.4435 10.6055L18.8516 15.5724H11.7673L10.4875 8.60363C10.4737 8.5285 10.4409 8.45813 10.3923 8.39918C10.3438 8.34023 10.281 8.29465 10.2098 8.26673L8.11364 7.44322C7.88261 7.35277 7.62191 7.46624 7.53118 7.69699C7.4406 7.92786 7.55405 8.18872 7.78495 8.27945L9.64882 9.01167L10.9513 16.1028C10.9703 16.2061 11.0249 16.2995 11.1056 16.3667C11.1864 16.434 11.2881 16.4708 11.3932 16.4708H11.6092L11.1159 17.8412C11.0955 17.8977 11.089 17.9583 11.097 18.0178C11.105 18.0773 11.1273 18.1341 11.1618 18.1832C11.1964 18.2323 11.2422 18.2724 11.2955 18.3001C11.3488 18.3278 11.408 18.3423 11.468 18.3423H11.8141C11.5996 18.5809 11.468 18.8951 11.468 19.2407C11.468 19.9838 12.0727 20.5882 12.8156 20.5882C13.5585 20.5882 14.1632 19.9838 14.1632 19.2407C14.1632 18.8952 14.0315 18.5809 13.8171 18.3423H16.7552C16.5407 18.5809 16.4091 18.8951 16.4091 19.2407C16.4091 19.9838 17.0136 20.5882 17.7567 20.5882C18.4998 20.5882 19.1042 19.9838 19.1042 19.2407C19.1042 18.8952 18.9727 18.5809 18.7583 18.3423H19.1791C19.3859 18.3423 19.5535 18.1747 19.5535 17.968C19.5535 17.7612 19.3859 17.5936 19.1791 17.5936H12.0006L12.4048 16.4707H19.1791C19.2743 16.4707 19.367 16.4405 19.4438 16.3844C19.5207 16.3283 19.5778 16.2492 19.6068 16.1586L21.4784 10.3191C21.4996 10.2533 21.5053 10.1835 21.495 10.1152C21.4847 10.0469 21.4588 9.98182 21.4192 9.92517ZM12.8156 19.8397C12.4853 19.8397 12.2167 19.5711 12.2167 19.2408C12.2167 18.9105 12.4853 18.6419 12.8156 18.6419C13.1459 18.6419 13.4145 18.9105 13.4145 19.2408C13.4145 19.5711 13.1459 19.8397 12.8156 19.8397ZM17.7567 19.8397C17.4264 19.8397 17.1578 19.5711 17.1578 19.2408C17.1578 18.9105 17.4264 18.6419 17.7567 18.6419C18.087 18.6419 18.3556 18.9105 18.3556 19.2408C18.3556 19.5711 18.087 19.8397 17.7567 19.8397Z" fill="white"/>
                            </g>
                            <defs>
                            <clipPath id="clip0_152_13176">
                            <rect width="14" height="14" fill="white" transform="translate(7.5 7)"/>
                            </clipPath>
                            </defs>
                            </svg>
                            <span className='booking_count'>{item.cart_qty}</span>
                        </div>
                        </Link>  
                    
                </div>
            );
        }; 
        const insertToCart= async (item,value)=>{
            localStorage.setItem('cartData', item);
            const formData = new FormData();
     
            formData.append("pump_id", item.id);
            formData.append("quantity", value);
            formData.append("session_id", localStorage.getItem('sessionId'));
            formData.append("avail_id", item.loc_id);
            
            try {
                const response = await customFetch.post('/add_cart',formData);
                const { status, message } = response.data;
                if (status === true) {
                    setApiSuccessMessage(message);
                    let cart_count = response.data.cart_count;
                    document.getElementsByClassName('booking_count')[0].innerHTML = cart_count;
                    document.getElementsByClassName('booking_count')[1].innerHTML = cart_count;
                } 
            } catch (err) {
                if (err.response.status === 401 || err.response.status === 500) {
                // setIsLogout(true)
                }
                
                // setErrorMessage('There is something wrong. Please try again');
                window.scrollTo(0,0);
            }
        }
    
    // const downloadFile = async (item) => {
    //     let techinal_pdf = encodeURI(item.technical_data_sheet);

    //     let pdf_url = '/file-blob?type=download&media='+techinal_pdf;
    //     const response = await customFetch.get(pdf_url);
    //     if(response.data.status === true) {
            
    //         let blob = b64toBlob(response.data.file_name_Base, 'application/pdf');

    //         const url = window.URL.createObjectURL(blob);
    //         const link = document.createElement('a');
    //         link.href = url;
    //         link.setAttribute('download', item.technical_data_sheet);
    //         document.body.appendChild(link);
    //         link.click();
           

            
    //     }
        

    // };

    // const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
    //     const byteCharacters = atob(b64Data);
    //     const byteArrays = [];
      
    //     for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    //       const slice = byteCharacters.slice(offset, offset + sliceSize);
      
    //       const byteNumbers = new Array(slice.length);
    //       for (let i = 0; i < slice.length; i++) {
    //         byteNumbers[i] = slice.charCodeAt(i);
    //       }
      
    //       const byteArray = new Uint8Array(byteNumbers);
    //       byteArrays.push(byteArray);
    //     }
          
    //     const blob = new Blob(byteArrays, {type: contentType});
    //     return blob;
    // }
            

    const actionDoing = (item) => {
        return(
            <div className="action_td">
                    {/* <Link style={item.techinal_data_sheet_status===0 ? {pointerEvents: "none",opacity: 0.5} : null} to={mediaFetch+'uploads/pump/'+item.technical_data_sheet} target="_blank">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="path-1-inside-1_137_5748" fill="white">
                        <path d="M18 15V12C18 11.8011 17.921 11.6103 17.7803 11.4697C17.6397 11.329 17.4489 11.25 17.25 11.25C17.0511 11.25 16.8603 11.329 16.7197 11.4697C16.579 11.6103 16.5 11.8011 16.5 12V15C16.5 15.1989 16.421 15.3897 16.2803 15.5303C16.1397 15.671 15.9489 15.75 15.75 15.75H2.25C2.05109 15.75 1.86032 15.671 1.71967 15.5303C1.57902 15.3897 1.5 15.1989 1.5 15V12C1.5 11.8011 1.42098 11.6103 1.28033 11.4697C1.13968 11.329 0.948912 11.25 0.75 11.25C0.551088 11.25 0.360322 11.329 0.21967 11.4697C0.0790178 11.6103 0 11.8011 0 12V15C0 15.5967 0.237053 16.169 0.65901 16.591C1.08097 17.0129 1.65326 17.25 2.25 17.25H15.75C16.3467 17.25 16.919 17.0129 17.341 16.591C17.7629 16.169 18 15.5967 18 15ZM13.215 11.085L9.465 14.085C9.33259 14.1896 9.16876 14.2465 9 14.2465C8.83124 14.2465 8.66741 14.1896 8.535 14.085L4.785 11.085C4.64836 10.956 4.56511 10.7805 4.55173 10.593C4.53834 10.4056 4.59578 10.22 4.7127 10.0729C4.82962 9.92583 4.99749 9.82798 5.18309 9.79874C5.3687 9.7695 5.55852 9.81098 5.715 9.915L8.25 11.94V1.5C8.25 1.30109 8.32902 1.11032 8.46967 0.96967C8.61032 0.829018 8.80109 0.75 9 0.75C9.19891 0.75 9.38968 0.829018 9.53033 0.96967C9.67098 1.11032 9.75 1.30109 9.75 1.5V11.94L12.285 9.915C12.3605 9.84371 12.45 9.78888 12.5478 9.75399C12.6457 9.7191 12.7497 9.70491 12.8533 9.71231C12.9569 9.71971 13.0578 9.74854 13.1496 9.79698C13.2415 9.84542 13.3223 9.91242 13.3869 9.99372C13.4516 10.075 13.4986 10.1689 13.5251 10.2693C13.5515 10.3697 13.5568 10.4745 13.5407 10.5771C13.5245 10.6797 13.4872 10.7778 13.4312 10.8653C13.3751 10.9527 13.3015 11.0275 13.215 11.085Z"/>
                        </mask>
                        <path d="M18 15V12C18 11.8011 17.921 11.6103 17.7803 11.4697C17.6397 11.329 17.4489 11.25 17.25 11.25C17.0511 11.25 16.8603 11.329 16.7197 11.4697C16.579 11.6103 16.5 11.8011 16.5 12V15C16.5 15.1989 16.421 15.3897 16.2803 15.5303C16.1397 15.671 15.9489 15.75 15.75 15.75H2.25C2.05109 15.75 1.86032 15.671 1.71967 15.5303C1.57902 15.3897 1.5 15.1989 1.5 15V12C1.5 11.8011 1.42098 11.6103 1.28033 11.4697C1.13968 11.329 0.948912 11.25 0.75 11.25C0.551088 11.25 0.360322 11.329 0.21967 11.4697C0.0790178 11.6103 0 11.8011 0 12V15C0 15.5967 0.237053 16.169 0.65901 16.591C1.08097 17.0129 1.65326 17.25 2.25 17.25H15.75C16.3467 17.25 16.919 17.0129 17.341 16.591C17.7629 16.169 18 15.5967 18 15ZM13.215 11.085L9.465 14.085C9.33259 14.1896 9.16876 14.2465 9 14.2465C8.83124 14.2465 8.66741 14.1896 8.535 14.085L4.785 11.085C4.64836 10.956 4.56511 10.7805 4.55173 10.593C4.53834 10.4056 4.59578 10.22 4.7127 10.0729C4.82962 9.92583 4.99749 9.82798 5.18309 9.79874C5.3687 9.7695 5.55852 9.81098 5.715 9.915L8.25 11.94V1.5C8.25 1.30109 8.32902 1.11032 8.46967 0.96967C8.61032 0.829018 8.80109 0.75 9 0.75C9.19891 0.75 9.38968 0.829018 9.53033 0.96967C9.67098 1.11032 9.75 1.30109 9.75 1.5V11.94L12.285 9.915C12.3605 9.84371 12.45 9.78888 12.5478 9.75399C12.6457 9.7191 12.7497 9.70491 12.8533 9.71231C12.9569 9.71971 13.0578 9.74854 13.1496 9.79698C13.2415 9.84542 13.3223 9.91242 13.3869 9.99372C13.4516 10.075 13.4986 10.1689 13.5251 10.2693C13.5515 10.3697 13.5568 10.4745 13.5407 10.5771C13.5245 10.6797 13.4872 10.7778 13.4312 10.8653C13.3751 10.9527 13.3015 11.0275 13.215 11.085Z" fill="#15223B"/>
                        <path d="M0 12H-16H0ZM2.25 17.25V33.25V17.25ZM15.75 17.25V33.25V17.25ZM13.215 11.085L4.3578 -2.23979L3.77053 -1.84942L3.21988 -1.4089L13.215 11.085ZM9.465 14.085L19.385 26.6386L19.4227 26.6089L19.4601 26.5789L9.465 14.085ZM8.535 14.085L-1.46012 26.5789L-1.42265 26.6089L-1.385 26.6386L8.535 14.085ZM4.785 11.085L-6.1978 22.7202L-5.72153 23.1698L-5.21012 23.5789L4.785 11.085ZM5.715 9.915L15.7011 -2.58611L15.1547 -3.02262L14.5722 -3.40979L5.715 9.915ZM8.25 11.94L-1.7361 24.4411L24.25 45.1992V11.94H8.25ZM9 0.75V16.75V0.75ZM9.75 11.94H-6.25V45.1992L19.7361 24.4411L9.75 11.94ZM12.285 9.915L22.2711 22.4161L22.7873 22.0037L23.2678 21.5502L12.285 9.915ZM34 15V12H2V15H34ZM34 12C34 7.55767 32.2353 3.29723 29.094 0.155961L6.46662 22.7834C3.60666 19.9234 2 16.0445 2 12H34ZM29.094 0.155961C25.9528 -2.9853 21.6923 -4.75 17.25 -4.75V27.25C13.2055 27.25 9.32658 25.6433 6.46662 22.7834L29.094 0.155961ZM17.25 -4.75C12.8077 -4.75 8.54723 -2.9853 5.40596 0.155961L28.0334 22.7834C25.1734 25.6433 21.2945 27.25 17.25 27.25V-4.75ZM5.40596 0.155961C2.2647 3.29723 0.5 7.55767 0.5 12H32.5C32.5 16.0445 30.8933 19.9234 28.0334 22.7834L5.40596 0.155961ZM0.5 12V15H32.5V12H0.5ZM0.5 15C0.5 10.9555 2.10666 7.07658 4.96662 4.21662L27.594 26.844C30.7353 23.7028 32.5 19.4423 32.5 15H0.5ZM4.96662 4.21662C7.82658 1.35666 11.7055 -0.25 15.75 -0.25V31.75C20.1923 31.75 24.4528 29.9853 27.594 26.844L4.96662 4.21662ZM15.75 -0.25H2.25V31.75H15.75V-0.25ZM2.25 -0.25C6.29452 -0.25 10.1734 1.35667 13.0334 4.21662L-9.59404 26.844C-6.45278 29.9853 -2.19235 31.75 2.25 31.75V-0.25ZM13.0334 4.21662C15.8933 7.07656 17.5 10.9555 17.5 15H-14.5C-14.5 19.4424 -12.7353 23.7028 -9.59404 26.844L13.0334 4.21662ZM17.5 15V12H-14.5V15H17.5ZM17.5 12C17.5 7.55763 15.7353 3.2972 12.594 0.155961L-10.0334 22.7834C-12.8933 19.9234 -14.5 16.0445 -14.5 12H17.5ZM12.594 0.155961C9.45278 -2.98529 5.19235 -4.75 0.75 -4.75V27.25C-3.29452 27.25 -7.17343 25.6433 -10.0334 22.7834L12.594 0.155961ZM0.75 -4.75C-3.69235 -4.75 -7.95278 -2.98529 -11.094 0.155961L11.5334 22.7834C8.67343 25.6433 4.79452 27.25 0.75 27.25V-4.75ZM-11.094 0.155961C-14.2353 3.2972 -16 7.55763 -16 12H16C16 16.0445 14.3933 19.9234 11.5334 22.7834L-11.094 0.155961ZM-16 12V15H16V12H-16ZM-16 15C-16 19.8402 -14.0772 24.4822 -10.6547 27.9047L11.9727 5.27728C14.5513 7.85591 16 11.3533 16 15H-16ZM-10.6547 27.9047C-7.23216 31.3272 -2.5902 33.25 2.25 33.25V1.25C5.89672 1.25 9.39409 2.69865 11.9727 5.27728L-10.6547 27.9047ZM2.25 33.25H15.75V1.25H2.25V33.25ZM15.75 33.25C20.5902 33.25 25.2322 31.3272 28.6547 27.9047L6.02728 5.27728C8.60591 2.69865 12.1033 1.25 15.75 1.25V33.25ZM28.6547 27.9047C32.0772 24.4822 34 19.8402 34 15H2C2 11.3533 3.44865 7.85591 6.02728 5.27728L28.6547 27.9047ZM3.21988 -1.4089L-0.53012 1.5911L19.4601 26.5789L23.2101 23.5789L3.21988 -1.4089ZM-0.455 1.53137C2.2374 -0.596189 5.5686 -1.75345 9 -1.75345V30.2465C12.7689 30.2465 16.4278 28.9755 19.385 26.6386L-0.455 1.53137ZM9 -1.75345C12.4314 -1.75345 15.7626 -0.59618 18.455 1.53137L-1.385 26.6386C1.57221 28.9754 5.23107 30.2465 9 30.2465V-1.75345ZM18.5301 1.5911L14.7801 -1.4089L-5.21012 23.5789L-1.46012 26.5789L18.5301 1.5911ZM15.7678 -0.550213C18.5461 2.07231 20.2388 5.64215 20.5111 9.45298L-11.4076 11.7331C-11.1086 15.9188 -9.24938 19.8397 -6.1978 22.7202L15.7678 -0.550213ZM20.5111 9.45298C20.7833 13.2638 19.6152 17.038 17.2379 20.0288L-7.81247 0.11701C-10.4236 3.40201 -11.7066 7.54744 -11.4076 11.7331L20.5111 9.45298ZM17.2379 20.0288C14.8606 23.0196 11.4472 25.0092 7.67324 25.6038L2.69294 -6.0063C-1.45224 -5.35321 -5.20132 -3.16799 -7.81247 0.11701L17.2379 20.0288ZM7.67324 25.6038C3.89932 26.1984 0.0396013 25.3548 -3.1422 23.2398L14.5722 -3.40979C11.0774 -5.73281 6.83808 -6.65938 2.69294 -6.0063L7.67324 25.6038ZM-4.2711 22.4161L-1.7361 24.4411L18.2361 -0.561113L15.7011 -2.58611L-4.2711 22.4161ZM24.25 11.94V1.5H-7.75V11.94H24.25ZM24.25 1.5C24.25 5.54456 22.6433 9.42346 19.7834 12.2834L-2.84404 -10.344C-5.98526 -7.20281 -7.75 -2.94239 -7.75 1.5H24.25ZM19.7834 12.2834C16.9235 15.1433 13.0446 16.75 9 16.75V-15.25C4.55761 -15.25 0.297188 -13.4853 -2.84404 -10.344L19.7834 12.2834ZM9 16.75C4.95545 16.75 1.07656 15.1433 -1.78338 12.2834L20.844 -10.344C17.7028 -13.4853 13.4424 -15.25 9 -15.25V16.75ZM-1.78338 12.2834C-4.64333 9.42343 -6.25 5.54452 -6.25 1.5H25.75C25.75 -2.94235 23.9853 -7.20278 20.844 -10.344L-1.78338 12.2834ZM-6.25 1.5V11.94H25.75V1.5H-6.25ZM19.7361 24.4411L22.2711 22.4161L2.2989 -2.58611L-0.236101 -0.561112L19.7361 24.4411ZM23.2678 21.5502C21.7322 22.9998 19.9122 24.1146 17.9232 24.824L7.1725 -5.31603C4.98787 -4.53679 2.9889 -3.31233 1.3022 -1.72021L23.2678 21.5502ZM17.9232 24.824C15.9341 25.5335 13.8194 25.8221 11.7132 25.6716L13.9933 -6.24702C11.6799 -6.41228 9.35724 -6.09531 7.1725 -5.31603L17.9232 24.824ZM11.7132 25.6716C9.60693 25.5212 7.55476 24.9349 5.68674 23.9499L20.6125 -4.35593C18.5608 -5.43784 16.3068 -6.08176 13.9933 -6.24702L11.7132 25.6716ZM5.68674 23.9499C3.81881 22.9649 2.17579 21.6027 0.861765 19.9496L25.9121 0.0378114C24.4688 -1.77791 22.6642 -3.27408 20.6125 -4.35593L5.68674 23.9499ZM0.861765 19.9496C-0.452322 18.2964 -1.40864 16.3884 -1.94673 14.3465L28.9968 6.19206C28.4058 3.94931 27.3554 1.85362 25.9121 0.0378114L0.861765 19.9496ZM-1.94673 14.3465C-2.48485 12.3045 -2.59302 10.173 -2.26436 8.08698L29.3457 13.0673C29.7067 10.7761 29.5879 8.4349 28.9968 6.19206L-1.94673 14.3465ZM-2.26436 8.08698C-1.93571 6.00106 -1.17743 4.00604 -0.0374643 2.22835L26.8998 19.5022C28.1519 17.5496 28.9847 15.3584 29.3457 13.0673L-2.26436 8.08698ZM-0.0374643 2.22835C1.10243 0.450771 2.5991 -1.07075 4.3578 -2.23979L22.0722 24.4098C24.0039 23.1258 25.6478 21.4546 26.8998 19.5022L-0.0374643 2.22835Z" fill="#15223B" mask="url(#path-1-inside-1_137_5748)"/>
                    </svg>
                </Link> */}
                <div className="action_eye">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.58 12C15.58 13.98 13.98 15.58 12 15.58C10.02 15.58 8.42004 13.98 8.42004 12C8.42004 10.02 10.02 8.41998 12 8.41998C13.98 8.41998 15.58 10.02 15.58 12Z" stroke="#15223B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 20.27C15.53 20.27 18.82 18.19 21.11 14.59C22.01 13.18 22.01 10.81 21.11 9.39997C18.82 5.79997 15.53 3.71997 12 3.71997C8.46997 3.71997 5.17997 5.79997 2.88997 9.39997C1.98997 10.81 1.98997 13.18 2.88997 14.59C5.17997 18.19 8.46997 20.27 12 20.27Z" stroke="#15223B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>{item.cart_count}</span>
                </div>
            </div>
        );
    }              

    return(
            <>
                <div className='Add_new_pump_block fire_pump_booking mobile_view_available'>
                    <div className='container'>
                        <div className='mobile_back_btn'>
                            <Link to="/stock-availability?n=from_compare" className="back_svg">
                                <img src={backBtn} alt="back btn" />
                            </Link>
                            <EnquiriesHead heading="Available Stock" />
                        </div> 
                    </div> 
                    <div className="available_table_block">
                        <div className='container'>
                            <div className="">
                                <div className="custom_dataTable available_table">
                                    <DataTable
                                    ref={dt}
                                    value={stocklist.data}
                                    selection={selectedProducts}
                                    onSelectionChange={(e) => setSelectedProducts(e.value)}
                                    dataKey="loc_id"
                                    >
                                    <Column field="model" header="Model" body={modelName} sortable></Column>
                                    <Column field="code" header="Code" sortable></Column>
                                    <Column field="Flow" header="Flow" body={flowName}  sortable></Column>
                                    <Column header="Pressure" field="pressure" body={pressureName}></Column>
                                    {/* <Column field="speed" header="Speed" sortable></Column> */}
                                    <Column field="pump_type" header="Pump Type" sortable></Column>
                                    {/* <Column field="primemover_type" header="Driver Type" sortable></Column> */}
                                    <Column field="controller" header="Controller" sortable></Column>
                                    <Column field="location" header="location" sortable body={location}></Column>
                                    <Column field="qty" header="Qty Available" sortable body={qtyavail}></Column>
                                    <Column body={compareShow} field="code" header="Compare" sortable></Column>
                                    <Column body={addToCart} field="cart_qty" header="Add To Cart" sortable></Column>
                                    <Column body={actionDoing} field="action" header="Action" sortable className="dots_col" style={{paddingRight:'40px', width: '156px;', minWidth: '156px;'}}></Column>                                    
                                    </DataTable> 
                                </div>
                                {
                                (stocklist.total>0) && <div className="card">
                                <Paginator first={first} rows={pagelimit} totalRecords={stocklist.total}  onPageChange={onPageChange} />
                            </div>
                            }
                            </div>
                        </div> 
                    </div>
                    {( checkeddata && checkeddata.length>0 )  && <div className="sticky_compare_block">  
                    <div className="container">
                        <div className="sticky_compare">
                            <ul>
                            {checkeddata.map((item, index) => (
                                <li key={index}>
                                 <div className="product_compare">
                                        {item.pump_type==='End Suction' && <div className="check_pump_main"> <img src={endSuction} alt="pump selected" className="es_check_img"/></div>}
                                        {(item.pump_type==='Splitcase' || item.pump_type==='Split case') && <div className="check_pump_main"> <img src={horizontalPump} alt="pump selected" className="hp_check_img"/></div>}
                                        {(item.pump_type==='Horizontal Pump'  || item.pump_type==="Vertical Turbine") && <div className="check_pump_main"> <img src={verticalPump} alt="pump selected" className="vt_check_img"/></div>  }
                                        <span className="product_name">Model : {item.model}</span>
                                        <span className="product_id">{item.code}</span>
                                    </div>
                                    <Link onClick={() => {removeSelected(item)}} className="red_cross">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.75049 14.25L14.2505 3.75" stroke="#BC141A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M14.2505 14.25L3.75049 3.75" stroke="#BC141A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                    </Link>
                                </li>
                            ))}
                            </ul>
                            {(checkedItems && checkedItems.length>1 && showtable) &&  <button disabled={checkedItems.length < 2}   className='darkred_btn' onClick={() => {redirectToDetail(checkedcode)}}>                                    <span>Compare</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                        <path d="M14.9302 5.92993L21.0002 11.9999L14.9302 18.0699" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M4 12H20.83" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </button>}
                        </div>            
                    </div>            
                    </div> }
                </div>
                <Modal show={show_warning} onHide={handleClose} centered className="delete_popup_modal" backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title className=""><h2>Stock Pumps</h2></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="confirm_msg">Pump with product number {selected_pump} already selected.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        {/* <Button variant="secondary" className="outline_btn" onClick={transferRecord}>Yes</Button> */}
                        <Button variant="primary" className="darkred_btn" onClick={handleClose}>Ok</Button>
                    </Modal.Footer>
                </Modal>
            </>
    );
}
export default FirePumpStockBookingMobile